import compose from 'lodash/fp/compose'
import map from 'lodash/fp/map'
import property from 'lodash/fp/property'
import { load_one } from '@/store/action-helpers'

// noinspection JSUnusedGlobalSymbols
export default {

    loadOne: load_one('files/:id'),

    loadAllByProductFileModels({ dispatch }, { productFileModels }) {
        return compose(

            promises => Promise.all(promises),

            map(id => dispatch('loadOne', { id })),

            map(property('file'))

        )(productFileModels)
    }

}
